/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{o as e,t,u as n}from"vendor/lit";import{a as r,t as i}from"vendor/decorate";import{AddVehicleSource as a,makeGarageViewEvent as o,showGarageView as s}from"components-garage/events";import{d as c}from"algolia/client";import{buttonStyles as l}from"components-garage/styles";var u=class extends t{constructor(...e){super(...e),this._showAddVehicleView=()=>{c().length===0?this.dispatchEvent(o(`addVehicle`,a.banner)):this.dispatchEvent(s)}}static{this.styles=[l,n`:host {
  width: 100%;
}

.wrapper {
  justify-content: space-between;
  align-items: center;
  gap: calc(2 * var(--space-unit));
  text-align: center;
  flex-direction: row;
  display: flex;
}

@media (min-width: 600px) {
  .wrapper {
    gap: calc(4 * var(--space-unit));
    text-align: left;
    flex-direction: row;
  }
}

kanter-icon {
  color: #000;
}

h2 {
  letter-spacing: .1em;
  font-size: calc(var(--body-font-size) * .1rem);
  font-family: var(--navigation-font-family);
  font-style: var(--navigation-font-style);
  font-weight: var(--navigation-font-weight);
  align-items: center;
  margin-block: 0;
  display: flex;
}

h2 span {
  padding-left: 15px;
}

@media (max-width: 768px) {
  h2 span {
    text-align: left;
    font-size: 11px;
  }
}

.button__primary b {
  display: none;
}

@media (max-width: 600px) {
  .button__primary {
    padding: 8px 10px;
  }

  .button__primary span {
    display: none;
  }

  .button__primary b {
    display: block;
  }
}

.uppercase {
  text-transform: uppercase;
}
`]}render(){return e`<div class="wrapper">
      <h2>
        <kanter-icon icon="vehicle" filled></kanter-icon>
        <span class="uppercase"
          >Select a vehicle & find the parts that fit</span
        >
      </h2>

      <button
        class="button__primary"
        data-ph-id="add-vehicle-cta"
        @click="${this._showAddVehicleView}"
      >
        <span>Select a vehicle</span><b>Select</b>
      </button>
    </div>`}};u=i([r(`kanter-garage-empty`)],u);export{u as EmptyGarage};